var obj  = [];
var all_obj = new Array();
var rows = '';

var shapelist = {Round:"Round",ROUND:"Round",B:"Round",BR:"Round",RB:"Round",RD:"Round",RBC:"Round",RoundBrilliant:"Round",RND:"Round",EUROPEANCUT:"Round",CushionBrilliant:"Cushion",CUSHION:"Cushion",Cushion:"Cushion",CB:"Cushion",CushionModified:"Cushion",C:"Cushion",CU:"Cushion",CMB:"Cushion",CUSH:"Cushion",CRC:"Cushion",SCMB:"Cushion",CM:"Cushion",CUSHIONMBR:"Cushion",Emerald:"Emerald",EMERALD:"Emerald",E:"Emerald",EM:"Emerald",EC:"Emerald",SquareEmerald:"Emerald",SQE:"Emerald",SQEM:"Emerald",SX:"Emerald",EMR:"Emerald",Heart:"Heart",HEART:"Heart",H:"Heart",HS:"Heart",HT:"Heart",MHRC:"Heart",Marquise:"Marquise",MARQUISE:"Marquise",MQB:"Marquise",M:"Marquise",MQ:"Marquise",MO:"Marquise",Oval:"Oval",OVAL:"Oval",O:"Oval",OV:"Oval",OMB:"Oval",Pear:"Pear",PEAR:"Pear",P:"Pear",PS:"Pear",PSH:"Pear",PB:"Pear",PMB:"Pear",Princess:"Princess",PRINCESS:"Princess",PRN:"Princess",PR:"Princess",PRIN:"Princess",PN:"Princess",PC:"Princess",PRI:"Princess",Asscher:"Asscher",ASSCHER:"Asscher",A:"Asscher",CSS:"Asscher",CSSC:"Asscher",AC:"Asscher",AS:"Asscher",Radiant:"Radiant",RADIANT:"Radiant",R:"Radiant",RAD:"Radiant",RA:"Radiant",RC:"Radiant",RDNv:"Radiant",SquareRadiant:"Radiant",SqRadiant:"Radiant",SQRADIANT:"Radiant",SQR:"Radiant",RADIANTSQUARE:"Radiant",RMB:"Radiant"}
var sym_pol_cut = {EX:"Excellent",Ex:"Excellent",Excellent:"Excellent",EXC:"Excellent",VG:"Very Good",Vg:"Very Good",VeryGood:"Very Good",G:"Good",Good:"Good",GD:"Good",Gd:"Good",F:"Fair",Fair:"Fair",P:"Poor",Poor:"Poor","":""}
var flor_list = {S:"Strong",Strong:"Strong",STG:"Strong",ST:"Strong",FL3:"Strong",M:"Medium",Medium:"Medium",MED:"Medium",FL2:"Medium",F:"Faint",Faint:"Faint",FNT:"Faint",FA:"Faint",FL1:"Faint",N:"None",None:"None",NON:"None",No:"None",NIL:"None",FL0:"None",nil:"None"}
var cert_list = {GIA:"GIA",G:"GIA",IGI:"IGI",I:"IGI",AGS:"AGS",AGSL:"AGS",AGS0:"AGS",A:"AGS",HRD:"HRD",H:"HRD"}

$(document).ready(function(e) { 
    
    sessionStorage.removeItem('temp_view1');
    
    var currency_symb = sessionStorage.getItem('currency')
    
    set_filter();
    
    fect_data_by_recent_id();
    
    $('#slider-price, #slider-carat, #slider-cut, #slider-color, #slider-clarity, #slider-polish, #slider-symmerty, #slider-fluorescence, #slider-depth, #slider-table ').on('change',function(){
        filter_load();
    });
    filter_price_min
    $('#filter_price_min, #filter_price_max, #filter_carat_min, #filter_carat_max, #filter_depth_min, #filter_depth_max, #filter_table_min, #filter_table_max ').on('change',function(){
        filter_load();
    }); 
});

function more_diamond(){
    
    if( parseInt($('#page_offset').val()) < parseInt($('#max_offset').val()) ){
        $('#page_offset').val(parseInt($('#page_offset').val())+1);
        filter_load(true);
      }
    
}

function set_filter(){  
    $.ajax({
        url: 'https://suppliers.arcticfamediamonds.com/getfilter',
        success: function (data) {
            
            obj = $.parseJSON(data);
            $(obj).each(function (index, element) {

                var price_total_from1 = (currency_symb == 'CAD' ?(element.price_total_from_in_currency) : (element.price_total_from_in_currency * currency_rate).toFixed(2));
                var price_total_to1 = (currency_symb == 'CAD' ? (element.price_total_to_in_currency) : (element.price_total_to_in_currency * currency_rate).toFixed(2));
                
                var filter_price_min = sessionStorage.getItem('price_f1');
                var filter_price_max = sessionStorage.getItem('price_t1');
                var filter_carat_min = sessionStorage.getItem('carat_f1');
                var filter_carat_max = sessionStorage.getItem('carat_t1');
                var filter_table_min = sessionStorage.getItem('table_f1');
                var filter_table_max = sessionStorage.getItem('table_t1');
                var filter_depth_min = sessionStorage.getItem('depth_f1');
                var filter_depth_max = sessionStorage.getItem('depth_t1');
                var filter_cut_min = sessionStorage.getItem('cut_f1');
                var filter_cut_max = sessionStorage.getItem('cut_t1');
                var filter_color_min = sessionStorage.getItem('color_f1');
                var filter_color_max = sessionStorage.getItem('color_t1');
                var filter_clarity_min = sessionStorage.getItem('clarity_f1');
                var filter_clarity_max = sessionStorage.getItem('clarity_t1');
                var filter_polish_min = sessionStorage.getItem('polish_f1');
                var filter_polish_max = sessionStorage.getItem('polish_t1');
                var filter_symmerty_min = sessionStorage.getItem('symmerty_f1');
                var filter_symmerty_max = sessionStorage.getItem('symmerty_t1');
                var filter_fluorescence_min = sessionStorage.getItem('fluorescence_f1');
                var filter_fluorescence_max = sessionStorage.getItem('fluorescence_to1');
                if(sessionStorage.getItem('shape1')){
                    var strVale = sessionStorage.getItem('shape1');
                    var resultarray = strVale.split(",");
                    var arraylenth = resultarray.length;
                    for (var i = 0; i < arraylenth; ++i) {
                        $("#"+resultarray[i]).parent().addClass('checked');
                        $("#"+resultarray[i]).attr('checked',true);
                    }
                }

                if(sessionStorage.getItem('origin1')){
                    var originval = sessionStorage.getItem('origin1');
                    $("#"+originval).parent().addClass('selected');
                    $("#"+originval).attr('checked',true);
                }else{
                    $("#ALL").parent().addClass('selected');
                    $("#ALL").attr('checked',true);
                }
                
                var price_min = (!filter_price_min ? price_total_from1 : filter_price_min);
                var price_max = (!filter_price_max ? price_total_to1 : filter_price_max);
                var carat_min = (!filter_carat_min ? element.size_from : filter_carat_min);
                var carat_max = (!filter_carat_max ? element.size_to : filter_carat_max);
                var depth_min = (!filter_depth_min ? element.depth_percent_from : filter_depth_min);
                var depth_max = (!filter_depth_max ? element.depth_percent_to : filter_depth_max);
                var table_min = (!filter_table_min ? element.table_percent_from : filter_table_min);
                var table_max = (!filter_table_max ? element.table_percent_to : filter_table_max);
                var cut_min = (!filter_cut_min ? 0 : filter_cut_min);
                var cut_max = (!filter_cut_max ? 4 : filter_cut_max);
                var color_min = (!filter_color_min ? 0 : filter_color_min);
                var color_max = (!filter_color_max ? 7 : filter_color_max);
                var clarity_min = (!filter_clarity_min ? 0 : filter_clarity_min);
                var clarity_max = (!filter_clarity_max ? 7 : filter_clarity_max);
                var polish_min = (!filter_polish_min ? 0 : filter_polish_min);
                var polish_max = (!filter_polish_max ? 5 : filter_polish_max);
                var symmerty_min = (!filter_symmerty_min ? 0 : filter_symmerty_min);
                var symmerty_max = (!filter_symmerty_max ? 5 : filter_symmerty_max);
                var fluorescence_min = (!filter_fluorescence_min ? 0 : filter_fluorescence_min);
                var fluorescence_max = (!filter_fluorescence_max ? 4 : filter_fluorescence_max);
                
                create_maxmin_scroller(price_total_from1,price_total_to1,'#slider-price',false,price_min,price_max);
                $('#slider-price').Link('lower').to($('#filter_price_min'));
                $('#slider-price').Link('upper').to($('#filter_price_max'));
                
                create_maxmin_scroller(element.size_from,element.size_to,'#slider-carat',true,carat_min,carat_max);
                $('#slider-carat').Link('lower').to($('#filter_carat_min'));
                $('#slider-carat').Link('upper').to($('#filter_carat_max'));
                
                create_maxmin_scroller(0,4,'#slider-cut',false,cut_min,cut_max);
                $('#slider-cut').Link('lower').to($('#filter_cut_min'));
                $('#slider-cut').Link('upper').to($('#filter_cut_max'));
                
                create_maxmin_scroller(0,7,'#slider-color',false,color_min,color_max);
                $('#slider-color').Link('lower').to($('#filter_color_min'));
                $('#slider-color').Link('upper').to($('#filter_color_max'));
                
                create_maxmin_scroller(0,7,'#slider-clarity',false,clarity_min,clarity_max);
                $('#slider-clarity').Link('lower').to($('#filter_clarity_min'));
                $('#slider-clarity').Link('upper').to($('#filter_clarity_max'));
                
                create_maxmin_scroller(0,5,'#slider-polish',false,polish_min,polish_max);
                $('#slider-polish').Link('lower').to($('#filter_polish_min'));
                $('#slider-polish').Link('upper').to($('#filter_polish_max'));
                
                create_maxmin_scroller(0,5,'#slider-symmerty',false,symmerty_min,symmerty_max);
                $('#slider-symmerty').Link('lower').to($('#filter_symmerty_min'));
                $('#slider-symmerty').Link('upper').to($('#filter_symmerty_max'));
                
                create_maxmin_scroller(0,4,'#slider-fluorescence',false,fluorescence_min,fluorescence_max);
                $('#slider-fluorescence').Link('lower').to($('#filter_fluorescence_min'));
                $('#slider-fluorescence').Link('upper').to($('#filter_fluorescence_max'));
                
                create_maxmin_scroller(element.depth_percent_from,element.depth_percent_to,'#slider-depth',true,depth_min,depth_max);
                $('#slider-depth').Link('lower').to($('#filter_depth_min'));
                $('#slider-depth').Link('upper').to($('#filter_depth_max'));
                
                create_maxmin_scroller(element.table_percent_from,element.table_percent_to,'#slider-table',true,table_min,table_max);
                $('#slider-table').Link('lower').to($('#filter_table_min'));
                $('#slider-table').Link('upper').to($('#filter_table_max'));
                
                filter_load();

            });
        },
        error: function (data) {
            console.log(data);
        }

        }); 
    
}

function create_maxmin_scroller(lb,ub,id,decimal,start,end){
        var param = {};
        if(id == '#slider-price'){
            param.start = [parseFloat(start),parseFloat(end)];
            param.range = { 'min' : parseInt(lb), 'max' : parseInt(ub)};
        }
        if(id == '#slider-carat'){
            param.start = [parseFloat(start),parseFloat(end)];
            param.range = { 'min' : parseFloat(lb), 'max' : parseFloat(ub)}
        }
        if(id == '#slider-cut'){
            param.start = [parseFloat(start),parseFloat(end)];
            param.range = { 'min' : parseFloat(lb), 'max' : parseFloat(ub)}
        }
        if(id == '#slider-color'){
            param.start = [parseFloat(start),parseFloat(end)];
            param.range = { 'min' : parseFloat(lb), 'max' : parseFloat(ub)}
        }
        if(id == '#slider-clarity'){
            param.start = [parseFloat(start),parseFloat(end)];
            param.range = { 'min' : parseFloat(lb), 'max' : parseFloat(ub)}
        }
        if(id == '#slider-polish'){
            param.start = [parseFloat(start),parseFloat(end)];
            param.range = { 'min' : parseFloat(lb), 'max' : parseFloat(ub)}
        }
        if(id == '#slider-symmerty'){
            param.start = [parseFloat(start),parseFloat(end)];
            param.range = { 'min' : parseFloat(lb), 'max' : parseFloat(ub)}
        }
        if(id == '#slider-fluorescence'){
            param.start = [parseFloat(start),parseFloat(end)];
            param.range = { 'min' : parseFloat(lb), 'max' : parseFloat(ub)}
        }
        if(id == '#slider-depth'){
            param.start = [parseFloat(start),parseFloat(end)];
            param.range = { 'min' : parseFloat(lb), 'max' : parseFloat(ub)}
        }
        if(id == '#slider-table'){
            param.start = [parseFloat(start),parseFloat(end)];
            param.range = { 'min' : parseFloat(lb), 'max' : parseFloat(ub)}
        }
        
        if(!decimal){

            param.format= wNumb({
                mark: '',
                decimals: 0
            });
            param.step = 1;
            param.margin = 1;
        }


        $(id).noUiSlider(param,true);

    }

function checkbox_check(obj){
        if($(obj).parent().hasClass('checked')){    
            $(obj).parent().removeClass('checked');
        }
        else{
            $(obj).parent().addClass('checked');
        }
        filter_load();
    }

function origin_check(obj){ 
        $(obj).parent().addClass('selected');
        $(obj).parent().siblings().removeClass('selected');
        filter_load();
    }   


function resetsearch(){
    
                $('.checkbox_btn').removeClass('checked');
                $('.checkbox_btn input').removeAttr('checked');
                $('.radio_btn').removeClass('selected');
                $('.radio_btn input').removeAttr('checked');
                sessionStorage.removeItem('price_f1');
                sessionStorage.removeItem('price_t1');
                sessionStorage.removeItem('carat_f1');
                sessionStorage.removeItem('carat_t1');
                sessionStorage.removeItem('table_f1');
                sessionStorage.removeItem('table_t1');
                sessionStorage.removeItem('depth_f1');
                sessionStorage.removeItem('depth_t1');
                sessionStorage.removeItem('cut_f1');
                sessionStorage.removeItem('cut_t1');
                sessionStorage.removeItem('color_f1');
                sessionStorage.removeItem('color_t1');
                sessionStorage.removeItem('clarity_f1');
                sessionStorage.removeItem('clarity_t1');
                sessionStorage.removeItem('polish_f1');
                sessionStorage.removeItem('polish_t1');
                sessionStorage.removeItem('symmerty_f1');
                sessionStorage.removeItem('symmerty_t1');
                sessionStorage.removeItem('fluorescence_f1');
                sessionStorage.removeItem('fluorescence_to1');
                sessionStorage.removeItem('shape1');
                sessionStorage.removeItem('origin1');
                
                set_filter();
                    
    }   

function compfun1(obj){
    $('.testcomp2').removeClass('compclick');
    $('.testcomp1').addClass('compclick');
    $('#comp_table, #recent_table').hide();
    $('#paged_table').show();
}
function compfun2(obj){
    $('.testcomp1').removeClass('compclick');
    $('.testcomp2').addClass('compclick');
    $('#paged_table, #comp_table').hide();
    $('#recent_table').show();  
}

function filter_toggle(obj){
    
        $('#advance_filters').slideToggle(1000);
        $(obj).children('.fa.fa-plus').toggleClass('active');
        $('#filters2').toggleClass('active');
        
}
function filter_toggle1(obj){
    
        $('#filters').slideToggle(1000);
        $(obj).children('.fa.fa-plus').toggleClass('active');
        $('#filters').toggleClass('active');
        
}
function get_diamonds(empty){
    $(".diamond-loader").show();
    $.ajax({
        url: 'http://suppliers.arcticfamediamonds.com/getdiamonds',
        type: 'POST',
        data: new FormData(jQuery('#diamond_search_form')[0]),
        mimeType: "form-data",
        contentType: false,
        processData: false,
        success: function (data) {
            obj = $.parseJSON(data);
            if(empty!= true){
            $('#diaomond_data_body').html('');
            }
            $('.tot_span').html('');
            if(obj.total_records == 0){
                $(".diamond-loader").hide();
                $('#total_num').html(0);
                $('#diaomond_data_body').append('<h3 style="margin:16% auto; width:30%;">NO DIAMOND FOUND!'); 
              	jQuery(".more_diamonds button").hide();
            }else{
                $(obj.diamonds).each(function(index, element) {

                    all_obj.push(element);

                    var sales_price = (currency_symb == 'CAD' ? 'CAD ' + (element.fame_price) : currency_symb+' '+ (element.fame_price * currency_rate).toFixed(2));

                    var datashape = element.shape.replace(/\s/g, "");
                    var datacut = element.cut.replace(/\s/g, "");
                    var dataclarity = element.clarity;
                    var datapolish = element.polish.replace(/\s/g, "");
                    var datasymmetry = element.symmetry.replace(/\s/g, "");
                    var datafluorescence = element.fluorescence;
                    var datalab = element.lab.replace(/\./g,"");

                    if(element.certificate_num.length > 25){
                        source = element.certificate_num;
                    }else if (cert_list[datalab] == 'GIA') {
                        var source = "https://www.gia.edu/report-check?reportno=" + element.certificate_num;
                    } else if (cert_list[datalab] == 'IGI') {
                        var source = "http://www.igiworldwide.com/verify.php?r=" + element.certificate_num;
                    } else if (cert_list[datalab] == 'AGS') {
                        var source = "https://agslab.com/ym-vdgr/diamonds/" + element.certificate_num;
                    } else if (cert_list[datalab] == 'HRD') {
                        var source = "https://my.hrdantwerp.com/?id=34&record_number=" + element.certificate_num;
                    } else {
                        source = '';
                    }

                    if(element.video_url){
                        var video_url = '<i class="fa fa-video-camera"></i>';
                    }else{
                        var video_url = '';
                    }
                    //alert(shapelist[datashape]);
                    //onclick="addcomp(this,'+ "'" + element.stock_num + "'" +');"
                  	//console.log(shapelist[datashape]);

                    var row = '<tr id="'+ element.stock_num +'"><td class="hide568 clickk"><div class="uncheck" onclick="addcomp(this,'+ "'" + element.stock_num + "'" +');"></div>'+video_url+'</td><td onclick="openpop(' + "'" + element.stock_num + "'" + ')" class="clickk"><p><img class="list_shape hide768" src="https://cdn.shopify.com/s/files/1/0242/8908/3447/files/'+shapelist[datashape].toLowerCase()+'-icon.png"></p><div class="show768 bckimg '+shapelist[datashape]+'"></div><div class="data">' + (shapelist[datashape] == '' ? '-' : shapelist[datashape]) + '</div><div class=" child_check"><div class="uncheck" onclick="addcomp(this,'+ "'" + element.stock_num + "'" +');"></div>'+video_url+'</div></td><td onclick="openpop(' + "'" + element.stock_num + "'" + ')"><div class="mrgnt">' + (element.carat == '' ? '-' : element.carat) + '<span class="show568">CARAT</span></div><div class="show568">' + (sym_pol_cut[datacut] == '' ? '-' : sym_pol_cut[datacut]) + '<span class="show768">CUT</span></div></td><td onclick="openpop(' + "'" + element.stock_num + "'" + ')"><div class="mrgnt">' + (element.color == '' ? '-' : element.color)  + '<span class="show568">COLOR</span></div><div class="show568">' + (element.clarity == '' ? '-' : element.clarity)  + '<span class="show568">CLARITY</span></div></td><td onclick="openpop(' + "'" + element.stock_num + "'" + ')" class="hide568">' + (element.clarity == '' ? '-' : element.clarity) + '</td><td onclick="openpop(' + "'" + element.stock_num + "'" + ')" class="hide568">' + (sym_pol_cut[datacut] == '' ? '-' : sym_pol_cut[datacut]) + '</td><td onclick="openpop(' + "'" + element.stock_num + "'" + ')" class="hide568">' + (sym_pol_cut[datapolish] == '' ? '-' : sym_pol_cut[datapolish]) + '</td><td onclick="openpop(' + "'" + element.stock_num + "'" + ')" class="hide768">' + (sym_pol_cut[datasymmetry] == '' ? '-' : sym_pol_cut[datasymmetry]) + '</td><td onclick="openpop(' + "'" + element.stock_num + "'" + ')" class="hide768">' + (flor_list[datafluorescence] == '' ? '-' : flor_list[datafluorescence]) + '</td><td class="hide568"><a target="_blank" href="' + (source == '' ? '-' : source) + '"><img style="width: 40%;" src="https://cdn.shopify.com/s/files/1/0242/8908/3447/files/'+cert_list[datalab]+'.jpg"></a></td><td onclick="openpop(' + "'" + element.stock_num + "'" + ')">' + sales_price + '<span class="show568">PRICE</span><a class="show568" href="premiumdiamond-details?diamond_id=' + element.stock_num + '" >view</a></td><td class="hide568" onclick="openpop(' + "'" + element.stock_num + "'" + ')"><div class="viewclick"><a class="show768" href="premiumdiamond-details?diamond_id=' + element.stock_num + '" >view</a><span class="hide768">View Details</span></div></td></tr>';

                    $('#diaomond_data_body').append(row);
                });
                $('.total_span').html(parseInt(obj.total_records));
                $('#total_num').html(parseInt(obj.total_records));    
                $(".diamond-loader").hide();
                $('#max_offset').val( ( obj.total_records % 50 == 0 ) ?  obj.total_records / 50 :  parseInt(obj.total_records / 50) + 1 );
                var newWindowWidth = $(window).width();
                if (newWindowWidth < 770) {
                    $('#diaomond_data_body tr td').removeAttr('onclick');
                }
                if(jQuery('#max_offset').val()==jQuery('#page_offset').val()){
                  jQuery(".more_diamonds button").hide();
                }else{
                  jQuery(".more_diamonds button").show();
                }
        	}
        },
        error: function (data) {
            console.log(data);
        }
    });
    $(document).ajaxComplete(function (event, xhr, settings) {
        if (settings.url === 'https://suppliers.arcticfamediamonds.com/getdiamonds') {
            compare_selected();
        }
    });
}

function sort_by(sort_by,obj){
    $(obj).parent().children('th').children('i').attr('class','');
    var order = "ASC";
    var classs = '';
    if(sort_by == $('#sort_by').val()){
        order = $('#sorting_order').val()== "DESC" ? "ASC" : "DESC";
        classs = order == "DESC" ? 'fa fa-chevron-down' : 'fa fa-chevron-up';
        $(obj).children('i').removeClass().addClass(classs);
    }
    else{
        $(obj).children('i').removeClass().addClass('fa fa-chevron-up');
    }
    $('#sorting_order').val(order);
    $('#sort_by').val(sort_by);
    $('#page_num').val(1);
    $('#diaomond_data_body').html('');
    filter_load(true);
    $('#diaomond_data_body').animate({ scrollTop: 0 }, "slow");
}

function openpop(id){
    var stored_id = sessionStorage.getItem('temp_view1');   
    
    if(stored_id==id){
        $('.diamond_information').animate({'opacity':0,'right':'-25%'},400);
        $('.diamond_list').removeClass('col-sm-9').addClass('col-sm-12');
        sessionStorage.removeItem('temp_view1');
        $('#'+id).removeClass('active').siblings().removeClass('active');
    }else{
        $('.diamond_information').animate({'opacity':1,'right':0},400);
        $('.diamond_list').removeClass('col-sm-12').addClass('col-sm-9');
        $('#'+id).addClass('active').siblings().removeClass('active');
        $('#diamond-info h3 i').attr("onclick","openpop('"+id+"')");
        sessionStorage.setItem('temp_view1',id);    
    $(all_obj).each(function(index , element) {
        if( id == element.stock_num){
            
            var sales_price = (currency_symb == 'CAD' ? 'CAD ' + (element.fame_price) : currency_symb+' '+ (element.fame_price * currency_rate).toFixed(2));
            
            var datashape = element.shape.replace(/\s/g, "");
            var datacut = element.cut.replace(/\s/g, "");
            var dataclarity = element.clarity;
            var datapolish = element.polish.replace(/\s/g, "");
            var datasymmetry = element.symmetry.replace(/\s/g, "");
            var datafluorescence = element.fluorescence;
            var datalab = element.lab.replace(/\./g,"");

            var measurements = element.width+"x"+element.length+"x"+element.depth;
            var vprefix = $('#vhidden').children('ul').children();
            vprefix.children('.vshapee').html(shapelist[datashape]);
            vprefix.children('.vdepth').html(element.depth_percent);
            vprefix.children('.vcolor').html(element.color);
            vprefix.children('.vclarity').html(element.clarity);
            vprefix.children('.vlab').html(cert_list[datalab]);
            vprefix.children('.vcut').html(sym_pol_cut[datacut]);
            vprefix.children('.vcarat').html(element.carat);
            vprefix.children('.vgirdle').html(element.girdle);
            vprefix.children('.vpolish').html(sym_pol_cut[datapolish]);
            vprefix.children('.vprice').html(sales_price);
            vprefix.children('.vsymmetry').html(sym_pol_cut[datasymmetry]);
            vprefix.children('.vtable').html(element.table_percent);
            vprefix.children('.vstockno').html(element.stock_num);
            vprefix.children('.vmeasure').html( measurements);
            $('.vdiamond').attr('href','premiumdiamond-details?diamond_id='+id);
            //var cart_diamond = element.certificate_num+','+cert_list[datalab]+','+element.clarity+','+element.color+','+element.origin+','+element.culet_size+','+sym_pol_cut[datacut]+','+element.depth_percent+','+element.stock_num+','+flor_list[datafluorescence]+','+element.depth+','+element.length+','+element.width+','+sym_pol_cut[datapolish]+','+shapelist[datashape]+','+element.carat+','+element.stock_num+','+sym_pol_cut[datasymmetry]+','+element.table_percent+','+element.fame_price*currency_rate+','+element.fame_price+','+element.supplier_name;
            //var cote = "'";
            //$('.vdiamond').attr('onclick','diamond_add_to_database('+cote+cart_diamond+cote+')');
        }
    }); 
    }
}

function filter_load(pass){
    
    sessionStorage.setItem('price_f1',$('input[name=filter_price_min]').val());
    sessionStorage.setItem('price_t1',$('input[name=filter_price_max]').val());
    sessionStorage.setItem('carat_f1',$('input[name=filter_carat_min]').val());
    sessionStorage.setItem('carat_t1',$('input[name=filter_carat_max]').val());
    sessionStorage.setItem('table_f1',$('input[name=filter_table_min]').val());
    sessionStorage.setItem('table_t1',$('input[name=filter_table_max]').val());
    sessionStorage.setItem('depth_f1',$('input[name=filter_depth_min]').val());
    sessionStorage.setItem('depth_t1',$('input[name=filter_depth_max]').val());
    sessionStorage.setItem('cut_f1',$('input[name=filter_cut_min]').val());
    sessionStorage.setItem('cut_t1',$('input[name=filter_cut_max]').val());
    sessionStorage.setItem('color_f1',$('input[name=filter_color_min]').val());
    sessionStorage.setItem('color_t1',$('input[name=filter_color_max]').val());
    sessionStorage.setItem('clarity_f1',$('input[name=filter_clarity_min]').val());
    sessionStorage.setItem('clarity_t1',$('input[name=filter_clarity_max]').val());
    sessionStorage.setItem('polish_f1',$('input[name=filter_polish_min]').val());
    sessionStorage.setItem('polish_t1',$('input[name=filter_polish_max]').val());
    sessionStorage.setItem('symmerty_f1',$('input[name=filter_symmerty_min]').val());
    sessionStorage.setItem('symmerty_t1',$('input[name=filter_symmerty_max]').val());
    sessionStorage.setItem('fluorescence_f1',$('input[name=filter_fluorescence_min]').val());
    sessionStorage.setItem('fluorescence_to1',$('input[name=filter_fluorescence_max]').val());
    var shape = [];
    $('.checked').children().each(function(i){
        shape[i] = $(this).val();
     });
    sessionStorage.setItem('shape1',shape);
    $('.selected').children().each(function(i){
        sessionStorage.setItem('origin1',$(this).val());
     });
    compfun1();
    get_diamonds(pass);
    }

function addcomp(obj,diamod_id){
    data1 = localStorage.getItem('compare_id1');
    if($(obj).hasClass('check')){
        $('#diaomond_data_body').children('#'+diamod_id+'').children('.clickk').children('.uncheck').removeClass('check');
      	$('#diaomond_data_body').children('#'+diamod_id+'').children('.clickk').children('.child_check').children('.uncheck').removeClass('check');
        $('#recent_data_body').children('#'+diamod_id+'').children('.clickk').children('.uncheck').removeClass('check');
        data1 = data1.replace("," + diamod_id, " ");
        data1 = data1.replace(diamod_id, " ");
    }
    else{
        $('#diaomond_data_body').children('#'+diamod_id+'').children('.clickk').children('.uncheck').addClass('check');
      	$('#diaomond_data_body').children('#'+diamod_id+'').children('.clickk').children('.child_check').children('.uncheck').addClass('check');
        $('#recent_data_body').children('#'+diamod_id+'').children('.clickk').children('.uncheck').addClass('check');
        if (localStorage.getItem('compare_id1')) {
            if (data1.search(diamod_id) == -1) {
                data1 = data1 + ',' + diamod_id + '';
            }

        } else {
            var data1 = diamod_id;
        }
    }
    localStorage.setItem('compare_id1', data1);
    count_nub();
}

function compare_selected() {
    if(localStorage.getItem('compare_id1')){    
        var strVale = localStorage.getItem('compare_id1');
        var blank = "";
        var tempresult = strVale.trim().split(",").map(String);
        if (tempresult[0] == "") {
            strVale = strVale.replace(blank + ",", "");
        }
        var resultarray = strVale.trim().split(",").map(String);
        var arraylenth = resultarray.length;
        if (resultarray[0] == "") {
            $('#comp_num').html(0);
        } else {
            $('#comp_num').html(arraylenth);
        }
        for (var i = 0; i < arraylenth; ++i) {
            $('#diaomond_data_body').children('#'+resultarray[i].trim()).children('.clickk').children('.uncheck').addClass('check');
          	$('#diaomond_data_body').children('#'+resultarray[i].trim()).children('.clickk').children('.child_check').children('.uncheck').addClass('check');
            $('#recent_data_body').children('#'+resultarray[i].trim()).children('.clickk').children('.uncheck').addClass('check');
        }
    }
}

function count_nub() {
    var strVale = localStorage.getItem('compare_id1');
    if(strVale){
    var blank = "";
    //var tempresult = strVale.split(",").map(Number);
    var tempresult = strVale.trim().split(",").map(String);
    console.log()
    if (tempresult[0] == "") {
        strVale = strVale.replace(blank + ",", "");
    }
    //var resultarray = strVale.split(",").map(Number);
    var resultarray = strVale.trim().split(",").map(String);
    var arraylenth = resultarray.length;
    if (resultarray[0] == "") {
        $('#comp_num').html(0);
    } else {
        $('#comp_num').html(arraylenth);
    }
    }
}   

function fect_data_by_recent_id(){              
    var hours = 24; // Reset when storage is more than 24hours
    var now = new Date().getTime();
    var setupTime = localStorage.getItem('setupTime1');
    if (setupTime == null) {
        localStorage.setItem('setupTime1', now)
    } else {
        if(now-setupTime > hours*60*60*1000) {
            localStorage.clear();
            localStorage.setItem('setupTime1', now);
        }
    }
    if(localStorage.getItem('rec_row1')){
        var data = localStorage.getItem("rec_row1");
        $('#recent_data_body').append(data); 
        var length=$('#recent_data_body').children().length;
        $('#recent_num').html(length);
        
    }
}

$(document).click(function(e){
  if ((!$("h4 span").is(e.target) && $("h4 span").has(e.target).length == 0) && (!$(".info").is(e.target) && $(".info").has(e.target).length == 0))
  {
    $(".info").hide();
  }
          
}); 

function showhidediv(obj){
             $("."+obj).addClass('show');
             $("."+obj).siblings().removeClass('show');
            }

$(document).ready(function(e) {
    
    $('.clickli').click(function(){
      $(this).addClass('active');
      $(this).siblings().removeClass('active');
    });
     
    $('h4 span').click(function(){  
      if($(this).hasClass('up')){
        $(this).removeClass('up');
        $(".info").hide();   
      }else{
        $('h4 span').removeClass('up');
        $(this).addClass('up');
        var z = this.id;
        $(".info").hide();
        $("."+z).show();
      }
    }); 
});

